import styled, { createGlobalStyle } from "styled-components";

export const fieldMinWidth = "440px";
const fieldMinHeight = "65px";

const fieldWithButtonsMinWidth = "434px";
const fieldWithButtonsMinWidthWithPadding = "491px";

const fieldControlButtonsHeight = "41px";

const maxScreenWidthWithoutOverlappingStepControls = "1606px";
const maxScreenHeightWithoutOverlappingStepControls = "940px";
const maxScreenHeightForFormInTwoLines = "650px";

export const windowWidth = {
  uhd: "2560px",
  laptop: {
    large: "1440px",
    medium: "1024px"
  },
  webDefault: "1280px",
  tablet: "768px",
  mobile: {
    large: "425px",
    medium: "375px",
    small: "320px"
  }
};

export default createGlobalStyle`

  #root {
    width: 100vw;
    height: 100vh;
  }

  * {
    font-family: 'Roboto', sans-serif;
    font: 'Roboto';
    padding: 0px;
    margin: 0px;
    box-sizing: border-box;

    .default-field {
      min-width: ${fieldMinWidth} !important;
      min-height: ${fieldMinHeight} !important;

      @media ( max-width: ${windowWidth.tablet} ) {
        min-width: 100% !important;
      }
    }
   
    .default-submit-button {
      background-color: ${(props) => props.theme.colors.primary} !important;Eduarad
    }
    
    .fillDualColor {
      fill: ${(props) => props.theme.colors.primary};

      @media ( max-width: ${windowWidth.tablet} ) {
        fill: ${(props) => props.theme.colors.secondary};
      }
    }
    
    .fillWithPrimaryColor {
      fill: ${(props) => props.theme.colors.primary};
    }

    .fillWithSecondaryColor {
      fill: ${(props) => props.theme.colors.secondary};
    }

    /* width */
    ::-webkit-scrollbar {
      width: 7px;
    }
    /* Track */
    ::-webkit-scrollbar-track {
      border-radius: 10px;
    }
    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: rgb(120,120,120);
      border-radius: 10px;
    }
    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: rgb(150,150,150);
      border-radius: 10px;
    }
  }

  a {
    border: none;
    outline: none;
    text-decoration: none;
  }

  #travel-modal{
    .MuiPaper-root {
      margin: auto;
      width: 94vw;
      max-width: 600px;
    }
  }
  
  .product-sidebar-icon svg {
    width: 100%;
    max-height: 100px;
  }
`;

/** Styled components */
const FieldWithActionButtons = styled.div`
  display: flex !important;
  flex-direction: row !important;
  align-items: flex-start !important;
  justify-content: flex-start !important;
  gap: 14px !important;
  width: ${fieldWithButtonsMinWidth} !important;
  min-width: 200px !important;
  min-height: ${fieldMinHeight} !important;

  @media (max-width: ${windowWidth.tablet}) {
    max-width: 100% !important;
  }

  .MuiFab-primary:not(.Mui-disabled) {
    background-color: ${(props) => props.theme.colors.primary} !important;
  }

  > :first-child {
    flex-grow: 1;
  }
`;

const FieldActionButtons = styled.div`
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: flex-start !important;
  gap: 10px !important;
  height: ${fieldControlButtonsHeight} !important;
`;

const DrawerKanbanSection = styled.div`
  width: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
  overflow: hidden;
  gap: 30px;

  > :first-child {
    flex-grow: 1;
    width: 100%;
    overflow: hidden;
  }

  @media (max-width: ${windowWidth.mobile.large}) {
    width: 100%;

    > :first-child {
      width: 100%;
      padding-bottom: 85px;
    }
  }

  @media (max-width: ${windowWidth.mobile.medium}) {
    > button {
      width: 150px !important;
    }
  }

  @media (max-width: ${windowWidth.mobile.small}) {
    > button {
      min-width: 125px !important;
      width: 125px !important;
    }
  }
`;

const DrawerKanbanSectionFormArea = styled.div`
  flex-grow: 1;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;

  @media (max-width: ${windowWidth.mobile.large}) {
    position: absolute;
    right: 0px;
    top: 0px;
    z-index: 1;
    background-color: white;
  }
`;

const DrawerFormContainer = styled.form`
  max-height: 99%;
  max-width: 497px;
  overflow-y: auto;
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 20px;
  gap: 10px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  box-shadow: 0px 1px 3px 1px rgba(0, 0, 0, 0.25);

  > :last-child {
    margin-top: 10px;
  }

  @media (max-width: ${windowWidth.mobile.large}) {
    padding: 15px;

    ::-webkit-scrollbar {
      width: 1px;
    }
  }

  @media (min-width: ${windowWidth.laptop
    .large}) and (min-height: ${maxScreenHeightForFormInTwoLines}) {
    max-width: 99%;
    flex-flow: row nowrap;
    writing-mode: vertical-lr;

    > * {
      writing-mode: horizontal-tb;
    }
  }

  @media (max-width: ${maxScreenWidthWithoutOverlappingStepControls}) and (min-width: ${windowWidth
  .laptop
  .large}) and (max-height: ${maxScreenHeightWithoutOverlappingStepControls}) {
    padding-bottom: 80px;
  }

  @media (max-width: ${windowWidth.laptop
    .medium}) and (max-height: ${maxScreenHeightWithoutOverlappingStepControls}) {
    padding-bottom: 80px;
  }

  @media (max-width: ${windowWidth.mobile.large}) {
    padding-bottom: 20px;
    width: 100%;
    box-shadow: none;
  }
`;

const DrawerFormFields = styled.div`
  width: auto;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-flow: column nowrap;
  gap: 15px;

  @media (min-width: ${windowWidth.laptop
    .large}) and (min-height: ${maxScreenHeightForFormInTwoLines}) {
    row-gap: 40px !important;
    flex-flow: row wrap;
    writing-mode: vertical-lr;

    > * {
      writing-mode: horizontal-tb;
    }
  }

  @media (max-width: ${windowWidth.laptop.large}) {
    width: 100%;
  }
`;

const DrawerFormButtons = styled.div`
  align-self: flex-end;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 15px;

  button {
    background-color: ${(props) => props.theme.colors.primary} !important;

    @media (max-width: ${windowWidth.mobile.medium}) {
      min-width: 130px !important;
      width: 130px !important;
    }
  }

  @media (max-width: ${windowWidth.mobile.large}) {
    align-self: center;
  }
`;

const GlobalStyledComponents = {
  DrawerFormFields,
  DrawerFormButtons,
  FieldActionButtons,
  DrawerKanbanSection,
  DrawerFormContainer,
  FieldWithActionButtons,
  DrawerKanbanSectionFormArea
};

export { GlobalStyledComponents };
